var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.2495 34.9995C70.2495 46.0901 65.0909 55.9759 57.0418 62.3881C50.8477 67.3167 43.1657 70 35.25 70C27.3343 70 19.6524 67.3167 13.4582 62.3881C5.4091 55.9759 0.250549 46.0901 0.250549 34.9995C0.250549 15.67 15.9206 0 35.25 0C54.5795 0 70.2495 15.67 70.2495 34.9995Z",
    fill: "#FFAC06",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2503 41.8908C43.3756 41.8908 49.9624 35.3039 49.9624 27.1786C49.9624 19.0533 43.3756 12.4665 35.2503 12.4665C27.1249 12.4665 20.5381 19.0533 20.5381 27.1786C20.5381 35.3039 27.1249 41.8908 35.2503 41.8908Z",
    fill: "#FFAC06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.042 62.3882C50.8478 67.3168 43.1658 70.0001 35.2501 70.0001C27.3344 70.0001 19.6525 67.3168 13.4583 62.3882C16.2885 53.0359 24.9741 46.2273 35.2501 46.2273C45.5262 46.2273 54.2118 53.0359 57.042 62.3882Z",
    fill: "#FFAC06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.dd97641014b021996f3a229608457cb0.svg";
export { ForwardRef as ReactComponent };